import API from "shared/services/Api";
import { IRestService } from "shared/types/RestService";

export const endService = async (data: IRestService) =>
  API.post(`oc/service/rest`, data);
